import React from 'react';
import { Row, Col, Form, Input, Select } from 'antd';
import { LEAD_STATUS_OPTIONS, LEAD_SOURCE_OPTIONS } from '../../constants/leadOptions';

const { Option } = Select;

interface LeadPropertyFormSectionProps {
  form: any;
  t: any;
}

const LeadPropertyFormSection: React.FC<LeadPropertyFormSectionProps> = ({ t }) => (
  <>
    <Row gutter={16}>
      <Col xs={24} sm={12}>
        <Form.Item
          name="name"
          label={t('sales:properties.table.name')}
          rules={[{ required: true, message: t('common:validation.required', 'This field is required') }]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          name="status"
          label={t('sales:leads.table.status')}
          rules={[{ required: true, message: t('common:validation.required', 'This field is required') }]}
        >
          <Select>
            {LEAD_STATUS_OPTIONS.map(opt => (
              <Option key={opt.value} value={opt.value}>{t('sales:leads.status.'+opt.value, opt.label)}</Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          name="source"
          label={t('sales:leads.table.source')}
          rules={[{ required: true, message: t('common:validation.required', 'This field is required') }]}
        >
          <Select>
            {LEAD_SOURCE_OPTIONS.map(opt => (
              <Option key={opt.value} value={opt.value}>{t('sales:leads.source.'+opt.value, opt.label)}</Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item
          name="description"
          label={t('sales:properties.table.description')}
        >
          <Input.TextArea rows={4} />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item
          name="notes"
          label={t('common:notes')}
        >
          <Input.TextArea rows={4} />
        </Form.Item>
      </Col>
    </Row>
  </>
);

export default LeadPropertyFormSection; 